/**
 * GENERATED by `scripts/generate-shell-registry.ts` — DO NOT EDIT.
 *
 * One static import per workspace package exposing the optional
 * `./contributions` door (arch §5.4 discovery; OpenSpec
 * `monorepo-shell-registry` task G1). Regenerate with:
 *
 *   pnpm tsx scripts/generate-shell-registry.ts
 *
 * CI runs the same script with `--check` and fails on drift, so adding a
 * `./contributions` door to a package is the ONLY edit a domain team makes —
 * this file follows mechanically and no central file is hand-touched.
 *
 * Because `_app.tsx` reaches this module, everything it pulls in lands in
 * every page bundle: contributions files must stay featherweight (metadata and
 * lazy `load` thunks only), which the registry-chunk bundle budget enforces.
 */
import type { ContributionModule } from '@heidi/runtime/shell';

import * as agents from '@heidi/agents/contributions';
import * as calls from '@heidi/calls/contributions';
import * as coding from '@heidi/coding/contributions';
import * as commerce from '@heidi/commerce/contributions';
import * as dictate from '@heidi/dictate/contributions';
import * as evidence from '@heidi/evidence/contributions';
import * as growth from '@heidi/growth/contributions';
import * as integrations from '@heidi/integrations/contributions';
import * as patients from '@heidi/patients/contributions';
import * as session from '@heidi/session/contributions';
import * as templates from '@heidi/templates/contributions';
import * as workspace from '@heidi/workspace/contributions';

export const contributionModules: readonly ContributionModule[] = [
  { package: '@heidi/agents', module: agents },
  { package: '@heidi/calls', module: calls },
  { package: '@heidi/coding', module: coding },
  { package: '@heidi/commerce', module: commerce },
  { package: '@heidi/dictate', module: dictate },
  { package: '@heidi/evidence', module: evidence },
  { package: '@heidi/growth', module: growth },
  { package: '@heidi/integrations', module: integrations },
  { package: '@heidi/patients', module: patients },
  { package: '@heidi/session', module: session },
  { package: '@heidi/templates', module: templates },
  { package: '@heidi/workspace', module: workspace },
];
